/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem } from 'src/app/model/interface/searchable.item';
import { SearchableSelectionType } from 'src/app/model/interface/searchable.selection';
import { CannedResponseType } from './response.type';

export class CannedResponse implements SearchableItem {
  ID: string;
  NAME: string;
  CONTENT: string;
  TYPE: CannedResponseType;
  BACKGROUND_COLOR: string;
  FOREGROUND_COLOR: string;

  // helpers
  active: boolean;
  allowed: boolean;
  selected: boolean;

  constructor(value: any = {}) {
    this.BACKGROUND_COLOR = '#000000';
    this.FOREGROUND_COLOR = '#ffffff';
    Object.assign(this, value);
  }

  static parseArray(json: any[]): CannedResponse[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new CannedResponse(j));
        }
      }
    }

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
